import { setLoader, setSnackbar } from 'redux/index';
import { useDispatch, useSelector } from 'react-redux';
import { reInviteChild, inviteChild, getCurrentChild } from 'services';
import { SecondaryButton } from 'components';

const InviteChildButton = ({ child, childId, label }) => {
	const dispatch = useDispatch();
	const isCaseManager = useSelector(
		(state) => state.user.user.type === 'case-manager'
	);
	const onInvite = async () => {
		if (child.status === 'created' || isCaseManager) {
			dispatch(setLoader(true));
			inviteChild(childId)
				.then(async () => {
					if (isCaseManager) {
						await getCurrentChild(childId, { fetch: true });
					}
					dispatch(
						setSnackbar({
							variant: 'success',
							message:
								child.status === 'invited'
									? 'Invitation successfully resent'
									: 'Invitation successfully sent',
						})
					);
				})
				.catch((err) => {
					const { message } = err.response.data || {};
					dispatch(
						setSnackbar({
							variant: 'error',
							message: message || 'Invitation could not be sent at this time.',
						})
					);
				})
				.finally(() => {
					dispatch(setLoader(false));
				});
			return;
		}
		if (childId) {
			dispatch(setLoader(true));
			reInviteChild(childId)
				.then(() => {
					dispatch(
						setSnackbar({
							variant: 'success',
							message: 'Invitation successfully resent',
						})
					);
				})
				.catch((err) => {
					const { message } = err.response.data || {};
					dispatch(
						setSnackbar({
							variant: 'error',
							message: message || 'Invitation could not be sent at this time.',
						})
					);
				})
				.finally(() => {
					dispatch(setLoader(false));
				});
		}
	};

	return (
		<SecondaryButton
			disabled={child.email && child.status !== 'active' ? false : true}
			onClick={() => onInvite()}>
			{label}
		</SecondaryButton>
	);
};

export default InviteChildButton;
